<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer001">
<h1 class="center">The Lost Codex</h1>
<h2 class="center" style="margin-top:40px;">An OPSIG Team Black Novel</h2>
<h3 class="center" style="margin-top:60px;">Alan Jacobson</h3>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Jacobson_LostCodex_1P.vue?24744674